<template>
  <div id="lottie" ref="lottie" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/turn.json'

export default {
  name: 'GachaLotteryModalAnimation',
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.lottie,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData
    }).addEventListener('DOMLoaded', () => {
      this.$emit('start')
    })
  }
}
</script>

<style lang="scss" scoped>
#lottie {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 70%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
